import React, { useState } from "react";
import { useParams } from "react-router-dom";
import TaskDetails from "./TaskDetails";
import { useNavigate } from "react-router-dom";
function TaskDetailRoute(props) {
  const [openComments, setOpenComments] = useState(true);
  const { id } = useParams();
  const navigate = useNavigate();
  return (
    <TaskDetails
      {...props}
      openComments={openComments}
      setOpenComments={setOpenComments}
      open={true}
      setOpen={() => {
        navigate("/projects");
      }}
      taskID={id}
    />
  );
}

export default TaskDetailRoute;
